import { Label } from '@/components/ui/label';
import React from 'react';

interface CustomFieldLabelProps extends React.ComponentProps<typeof Label> {
  required?: boolean;
}

export function CustomFieldLabel({
  required,
  children,
  ref,
  ...props
}: CustomFieldLabelProps) {
  return (
    <Label ref={ref} {...props}>
      {children} {required && <span className='text-destructive'> *</span>}
    </Label>
  );
}
